import { Pipe, PipeTransform, inject } from '@angular/core';
import { Resident } from '../models/resident.model';
import { PartnerPaymentGuardService } from '../../core/services/partner-payment-guard/partner-payment-guard.service';

@Pipe({
  name: 'hasNoValidPaymentMethod',
  standalone: true,
})
export class HasNoValidPaymentMethodPipe implements PipeTransform {
  private partnerPaymentGuardService = inject(PartnerPaymentGuardService);

  transform(resident: Resident): boolean {
    return this.partnerPaymentGuardService.hasNoValidPaymentMethod(resident);
  }
}
